import { SECTION_ANY_ID, BookingStatusNames, BookingMethods } from "shared-types/index";
import { cloneDeep, isEmpty } from "lodash-es";
import { TableDragService } from "app/services/tableDrag/TableDrag.service";
import ObjectCopyService from "external-services/object-copy-service/index";
import moment from 'moment';
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import AdminService from "external-services/diary-admin-service/admin.service";
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import BookingIntervalService from "app/services/bookingInterval/bookingInterval.service";
import MaxOccupancyService, { OVER_MAX } from "app/services/maxOccupancy/maxOccupancy.service";
import BookingDragService from 'app/services/bookingDrag/bookingDrag.service';
import BookingLookupService from "external-services/booking-lookup-service/index";
import BookingUpdateService from "external-services/booking-update-service/index";
import TableJoinService from "app/services/tableJoin/tableJoin.service";
import DateUtilsService from 'external-services/date-utils-service';
import TablesLookupService from "external-services/tables-lookup-service/tablesLookup.service";
import ServiceDetectionService from "external-services/service-detection-service/serviceDetection.service";
import StaffService from 'external-services/staff-service/staff.service';
import store from 'appRoot/Store';
import { bookingActions, loadBookingsFromCurrentSchedule, syncCouchBookingUpdates } from 'app/reducers/booking/slice';
import ViewActionsService from 'app/actions/view.actions';
import { loadFloorplanBookings } from 'floorplan-v2/app/reducers/bookings/slice';

const NS = 'DragBookingConfirmCtrl';

export default function DragBookingConfirmCtrl(
  $q, $mdDialog, $interpolate, unregister,
  toTable, toTablesArray, fromTable, fromTableArray, isError, isFloorPlanV2, layouts, isOverlap, tableJoinSwapError, hasSwappedTableChanged, tableName, newTime, schedule, dragBooking, swapWithBooking, $scope, allTimes
) {
  "ngInject";

  const vm = this;
  let settings;
  let hasEvents = false;
  let hadEvents = false;
  let hasEventsActive = false;
  let maxOccupancyEnabled = false;
  let isStickyService = false;
  let selectedSection;
  let coversBookingIntervals;

  //-- define public properites
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.SUCCESS = 2;
  vm.ERROR = 3;
  vm.state = vm.ENTER;
  vm.services = [];
  vm.fromServices = [];
  vm.msgHeader = '<b>Update: {{dragBookingOrg.name}}</b>  <hr width="600px">';

  vm.toServices = [];

  vm.dragBooking = dragBooking;

  // Always default to move only selected table (false)
  vm.dragBooking.enableGroupDrag = false;
  vm.dragBookingOrg = ObjectCopyService.angularSafeCopy(dragBooking);
  // vm.three;
  vm.swapWithBooking = ObjectCopyService.angularSafeCopy(swapWithBooking);
  vm.sendSms = false;
  vm.sendEmail = false;
  vm.isFloorPlanV2 = isFloorPlanV2;
  vm.isError = isError;
  vm.isOverlap = isOverlap;
  vm.tableJoinSwapError = tableJoinSwapError;
  vm.hasSwappedTableChanged = hasSwappedTableChanged;
  vm.tableName = tableName;
  //-- define public methods
  vm.cancel = cancel;
  vm.save = save;
  vm.toggleTableDrag = toggleTableDrag;
  vm.isActiveBookingStatus = vm.dragBooking.status?.name === BookingStatusNames.Confirmed || vm.dragBooking.status?.name === BookingStatusNames.Unconfirmed;
  vm.isVenueSmsEnabled = AdminService.getVenue().smsEnabled;
  vm.overCapacity = false

  // check couch url/name still correct
  AdminService.restartPeriodicCouchNameCheck(); // restarts the timer
  AdminService.loadVenue(AdminService.getVenue().id, true, true).catch(function (err) {
    console.error(err);
  });

  GeneralSettingsService.get().then(function (s) {
    settings = s;
    maxOccupancyEnabled = s.enableMaxOccupancy;
    isStickyService = s.isStickyService;
    init();
  });
  const listeners = [];
  listeners.push($scope.$on('$destroy', () => unregister(listeners)));
  listeners.push(ViewActionsService.handleCloseDragBookingConfirmation(() => closeDialog()));

  function init() {
    vm.toServices = [];

    vm.tableChangeSwapErrorMsg = `Based on Pax requirements of the table, this will be moved to table ${vm.tableName} ${isOverlap ? 'and will cause an overlap' : ''}`;
    SectionLookupService.getSectionById(fromTable.sectionId).then(sectionsLookup => {
      vm.fromSection = sectionsLookup;
    }).catch(error => {
      vm.fromSection = { errorMessage: "Failed to retrieve table's section name" }
    });
    SectionLookupService.getSectionById(toTable.sectionId).then(sectionsLookup => {
      vm.toSection = sectionsLookup;
    }).catch(error => {
      vm.toSection = { errorMessage: "Failed to retrieve table's section name" }
    });
    /**
     * Just in case the service id on the booking is no longer valid, we set it to the first valid service id we can find
     */
    BookingDragService.setServiceId(dragBooking, schedule.serviceLayouts);

    $scope.selected = 0;
    $scope.selectedID = 0;
    $scope.selectedType = 0;
    $scope.setFromID(0);

    const includeStartButNotEnd = '[)';
    const newService = schedule.services.find(({ startTime, endTime }) => moment(newTime).isBetween(startTime, endTime, undefined, includeStartButNotEnd));
    // When true, do not consider the overlapping services for "setToID".
    const doesBookingTimeFallWithinService = TableDragService.doesBookingTimeFallWithinService(newTime, fromTable, toTable, vm.dragBookingOrg, schedule.services);
    $scope.setToID(!doesBookingTimeFallWithinService && newService ? newService._id : vm.dragBookingOrg.serviceId);


    /**
     * Variables explained:
     * hasEvents: true if the target booking falls on a section (in an event) regardless of if it is set to 'Closed'
     * hasEventsActive: true if the target booking falls on a section (in an event) that is NOT set to 'Closed'
     * hadEvents: true if booking being dragged came from an event
     */
    hasEvents = BookingDragService.checkForLegitEvent(schedule.services, newTime, toTable, false);
    hasEventsActive = BookingDragService.checkForLegitEvent(schedule.services, newTime, toTable, true);
    hadEvents = BookingDragService.checkForLegitEvent(schedule.services, vm.dragBookingOrg.time, fromTable, false);

    if (maxOccupancyEnabled) {
      initMaxOccupancy();
    }

    // if true, new service doesn't get pre-selected by default
    let sticksToOriginalService = BookingDragService.bookingComesFromPaidService(schedule.services, vm.dragBookingOrg.time, vm.dragBookingOrg.serviceId);

    //1. so first thing loop over each of the services
    schedule.services.forEach(service => {

      const draggedBookingIsWithinService = DateUtilsService.isInBetweenDates(dragBooking.time, service.startTime, service.endTime);
      const isOriginalServiceDraggedFrom = vm.dragBookingOrg.serviceId === service._id;
      if (isOriginalServiceDraggedFrom || draggedBookingIsWithinService) {
        /**
         * Adds to the `fromServices` the service (or event) you dragged from,
         * plus (if you dragged from an event) any services that overlap the event.
         */
        vm.fromServices.push(service);

        // then selects the service you dragged from in the `fromServices` list
        if (isOriginalServiceDraggedFrom) {
          vm.originalService = service;
          $scope.setFromID(service._id);
        }
      }

      if (isOriginalServiceDraggedFrom) { // this is the service/event you dragged from

        // always show the service you dragged from
        vm.toServices.push(service);

        // and keep it selected if the service had a payment or booking option attached to it
        const selectedServiceId = BookingDragService.getSelectedServiceIdForOriginalServiceDraggedFrom(service, sticksToOriginalService, hasEvents);
        if (selectedServiceId) {
          $scope.setToID(selectedServiceId);
        }

      } else if (DateUtilsService.isInBetweenDates(newTime, service.startTime, service.endTime)) { // this is for the service/event you dropped onto
        // checks if service's sectionLayouts match the toTable and that they are not closed (layoutId is truthy)
        const serviceSectionMatchesTableSection = service.sectionLayouts
          .some(({ sectionId, layoutId }) => toTable.sectionId === sectionId && layoutId);

        // only interested in sections that match toTable.sectionId
        if (serviceSectionMatchesTableSection) {

          const isEventType = BookingDragService.serviceIsEventType(service.type);
          if (hasEventsActive && isEventType) {
            if (!doesBookingTimeFallWithinService) {
              $scope.setToID(service._id);
            }
            vm.toServices.push(service);
          }

          if (!hasEvents && !isEventType) {
            vm.toServices.push(service);
          }

          const selectedServiceId = BookingDragService.getSelectedServiceIdForServiceDraggedTo(service, sticksToOriginalService, hasEvents, vm.dragBookingOrg.serviceId);
          if (!doesBookingTimeFallWithinService && selectedServiceId) {
            $scope.setToID(selectedServiceId);
          }
        }
      }
      if (isStickyService && vm.originalService) { // Ignore all selected service logic if isStickyService is enabled - Always point to the same service selected before dragging
        $scope.setToID(vm.originalService._id);
      }
    }); // end forEach schedule.services


    if ($scope.toID === 0) {
      $scope.setToID(vm.toServices[0]._id);
    }

    if (vm.toServices.length === 1) {
      $scope.setToID(vm.toServices[0]._id);
    }

    vm.staffEditEnabled = (settings.staffEditEnabled && vm.dragBooking.method !== BookingMethods.walkin) ? true : false;
    // vm.staffEditRequired = (settings.staffEditRequired && vm.staffEditEnabled) ? settings.staffEdit.staffEditQuickEdit : false;
    vm.staffEditRequired = StaffService.checkValidityForStaffName(settings.staffEditRequired, vm.staffEditEnabled, settings.staffEdit, (settings.staffEdit?.staffEditQuickEdit || settings.staffEdit?.staffEditTableEdit));

    var msg = tablesDrag(vm.msgHeader, dragBooking.enableGroupDrag);
    var exp = $interpolate(msg);
    vm.msg = exp(vm);
  }

  function toggleTableDrag(enableGroupDrag) {
    var msg = tablesDrag(vm.msgHeader, enableGroupDrag);
    if (maxOccupancyEnabled) { // Calculate Max Occupancy again after toggling of table drag join
      initMaxOccupancy();
    }
    var exp = $interpolate(msg);
    vm.msg = exp(vm);
  }

  function addOverPaxAlert(msg) {
    return msg += `<div class="alert-warning"><md-icon class="mdi mdi-alert"></md-icon>
            <span class="strong">Table Size</span>
            <span >This table is normally set for ${toTable.capacity} guests!</span>
          </div>`;
  }

  function tablesDrag(msg, groupDrag) {
    const tablesLookup = getTablesLookUp();
    vm.updatedDragBooking = ObjectCopyService.angularSafeCopy(dragBooking);
    groupDrag = swapWithBooking ? true : groupDrag;
    var index = vm.updatedDragBooking.tables.findIndex(table => table._id === fromTable._id);
    if (index > -1) {
      if (groupDrag) {
        // add the to table
        vm.updatedDragBooking.tables = toTablesArray;
        if (isError) {
          vm.isError = true;
        }
      } else {
        vm.isError = false;
        /**
         * removed `vm.tableJoinSwapError = false` as it is never called for timeline view
         * and always false for legacy floorplan view.
         * However, Floorplan V2 passes this value in via props, so it can't be hardcoded here.
         */
        vm.updatedDragBooking.tables.splice(index, 1);
        vm.updatedDragBooking.tables.push(toTable);
      }

      const tableJoin = TableJoinService.setTableJoinForBooking(vm.updatedDragBooking, layouts);
      if (!isEmpty(tableJoin)) {
        vm.updatedDragBooking.tableJoin = tableJoin;
      } else {
        delete vm.updatedDragBooking.tableJoin;
      }

    }
    vm.overCapacity = toTable.capacity < dragBooking.people
    if (vm.overCapacity) {
      msg = addOverPaxAlert(msg);
    }

    // check for swapping booking
    if (swapWithBooking) {
      vm.swapWithBookingOrg = ObjectCopyService.angularSafeCopy(swapWithBooking);
      let sticksToOriginalService = BookingDragService.bookingComesFromPaidService(schedule.services, vm.swapWithBookingOrg.time, vm.swapWithBookingOrg.serviceId);

      swapWithBooking.tables = fromTableArray;

      if (swapWithBooking.serviceId !== vm.dragBookingOrg.serviceId && !sticksToOriginalService) {
        /**
         * We could just swap the services, like this:
         * swapWithBooking.serviceId = vm.dragBookingOrg.serviceId;
         * but if the dragged booking's service is no longer valid, we want to make sure a valid service id is chosen,
         * hence the use of `BookingDragService.setServiceId`
         */
        BookingDragService.setServiceId(swapWithBooking, schedule.serviceLayouts, fromTable);
      }
    }

    if (newTime) {
      vm.updatedDragBooking.time = newTime;
    }

    // define msg
    //   var msg = '<b>Update: {{dragBookingOrg.name}}</b>';
    if (vm.dragBookingOrg.time.toString() !== vm.updatedDragBooking.time.toString()) {

      msg += `Change the time to ${moment(vm.updatedDragBooking.time).format("h:mm a")}`;
      if (schedule) {
        var matchedService = ServiceDetectionService.getBookingService(vm.updatedDragBooking, schedule);
        if (matchedService && matchedService.lastBookingTime < vm.updatedDragBooking.time) {
          msg += `<br>${moment(vm.updatedDragBooking.time).format("h:mm a")} is after your last booking time of ${moment(matchedService.lastBookingTime).format("h:mm a")}`;
          vm.matchedService = matchedService;
        }
      }
    }


    // https://nowbookit.atlassian.net/browse/NBI-4728 Hotfix where the updated table name was not getting picked. - we need to choose the latest name from the tableLookup.

    if (vm.dragBookingOrg.tables !== vm.updatedDragBooking.tables) {
      const fromTableArrayNames = groupDrag
        ? TablesLookupService.getTableListAsString(vm.dragBookingOrg.tables, tablesLookup)
        : TablesLookupService.getTableListAsString([fromTable], tablesLookup);
      const toTableArrayNames = TablesLookupService.getTableListAsString(vm.updatedDragBooking.tables, tablesLookup);
      msg += `<br>Move to ${toTableArrayNames} from  ${fromTableArrayNames}`;  // vm.dragBookingOrg.tables[0].name + ' from  ' + dragBooking.tables[0].name
    }

    if (swapWithBooking) {
      const dragBookingTables = TablesLookupService.getTableListAsString(vm.dragBookingOrg.tables, tablesLookup);
      const swapBookingTables = TablesLookupService.getTableListAsString(vm.swapWithBookingOrg.tables, tablesLookup);
      msg = ''
      if (vm.overCapacity) {
        msg = addOverPaxAlert(msg);
      }
      msg += `Swap <b>{{dragBookingOrg.name}}</b> at {{dragBookingOrg.time | date : "h:mm a"}}, ${dragBookingTables}<br>`;
      msg += `with <b>{{swapWithBookingOrg.name}}</b> at {{swapWithBookingOrg.time | date : "h:mm a"}}, ${swapBookingTables}`;
    }
    return msg;
  }

  function getTablesLookUp() {
    return TablesLookupService.getTablesLookup();
  }

  function cancel() {
    $mdDialog.hide();
  }


  $scope.setToID = function (serviceId) {
    $scope.toID = serviceId;
    showMaxOccupancyMessage();
  };


  $scope.setFromID = function (name) {
    $scope.fromID = name;
  };

  /**
   * Loads data needed for Max Occupancy calculations
   */
  function initMaxOccupancy() {

    SectionLookupService.getSectionsLookUp()
      .then(sectionsLookup => {
        vm.sectionsLookup = sectionsLookup;
        selectedSection = sectionsLookup[toTable.sectionId];
      });

    BookingLookupService.getBySchedule(schedule)
      .then(({ bookings }) => {

        /**
         * `bookingsInSection` gets all bookings in the same section.
         * Includes all services for the day, but `bookingIntervals` is filtered to the current service, so it
         * narrows down the list in `BookingIntervalService.getCoversPerScheduleInterval`.
         */
        const bookingsInSection = bookings.filter(booking => {
          return booking._id !== dragBooking._id && SectionLookupService.checkIfSectionExists(booking, toTable.sectionId);
        });

        coversBookingIntervals = BookingIntervalService.getCoversPerMinuteInterval(cloneDeep(allTimes), bookingsInSection, [selectedSection]).filter(val => val.coversTotal > 0);
        showMaxOccupancyMessage(bookings);
      });
  }

  function getSectionId(booking) {

    if (booking.preferredSectionId === SECTION_ANY_ID && booking.tables && booking.tables.length) {
      return booking.tables[0].sectionId;
    }

    return booking.preferredSectionId;
  }

  /**
   * Determines if the Max Occupancy message should be shown
   */
  function showMaxOccupancyMessage(bookings = {}) {
    let maxOccCssClassName = '';

    if (!maxOccupancyEnabled || !selectedSection) {
      return;
    }

    dragBooking = {
      // copies the booking with new time
      ...dragBooking,
      time: !!swapWithBooking ? dragBooking.time : newTime,
      bookingMin: undefined // forces it to recalculate
    }

    vm.isMultipleSection = BookingIntervalService.checkIfBookingOverMultipleSections(vm.updatedDragBooking);
    if (vm.isMultipleSection) {
      let isOverMax = '';
      for (const propName in vm.sectionsLookup) {
        const section = vm.sectionsLookup[propName];
        if (section._id !== SECTION_ANY_ID && isOverMax !== OVER_MAX) {

          // Need to calculate the bookings and coversInterval for every section and then find out if any section violates the max occupancy.
          const bookingsInSection = bookings.filter(booking => {
            return booking._id !== dragBooking._id && getSectionId(booking) === section._id;
          });
          coversBookingIntervals = BookingIntervalService.getCoversPerMinuteInterval(cloneDeep(allTimes), bookingsInSection, [section]).filter(val => val.coversTotal > 0);
          isOverMax = MaxOccupancyService.checkForCovidMaxOccupancy(vm.updatedDragBooking, coversBookingIntervals, [section], vm.isMultipleSection);
        }
        maxOccCssClassName = isOverMax;
      }

    } else {
      maxOccCssClassName = MaxOccupancyService.checkForCovidMaxOccupancy(vm.updatedDragBooking, coversBookingIntervals, [selectedSection], vm.isMultipleSection);
    }
    vm.showMaxOccupancyMessage = maxOccCssClassName === OVER_MAX;

  }

  function closeDialog() {
    if (vm.timeoutForLoading) {
      clearTimeout(vm.timeoutForLoading);
    }
    $mdDialog.hide({ isSaved: true });
  }
  function save() {
    // check staff name
    if (vm.staffEditRequired && vm.staffEditEnabled && !vm.staffName) {
      vm.dragBookingForm.staffName.$setTouched();
      return;
    }
    //
    if (vm.state === vm.ENTER) {
      vm.state = vm.LOADING;
      var promises = [];

      dragBooking.serviceId = $scope.toID;
      dragBooking.serviceIdOverRide = $scope.toID;
      dragBooking = {
        ...dragBooking,
        time: !!swapWithBooking ? dragBooking.time : vm.updatedDragBooking.time,
        tables: vm.updatedDragBooking.tables,
        tableJoin: vm.updatedDragBooking.tableJoin
      }; // Updating the original DragBooking with the changed drag booking information in toggleDrag

      // sets the section of the dragged and swapped bookings
      BookingDragService.setSectionOfDraggedBooking(dragBooking, fromTable.sectionId, toTable.sectionId, swapWithBooking);
      const bookingIds = [dragBooking._id];
      promises.push(BookingUpdateService.updateFromAnywhere(dragBooking, vm.dragBookingOrg, null, { smsNotify: vm.sendSms, emailNotify: vm.sendEmail }, vm.staffName, schedule));
      if (swapWithBooking) {
        bookingIds.push(swapWithBooking._id);
        promises.push(BookingUpdateService.updateFromAnywhere(swapWithBooking, vm.swapWithBookingOrg, null, { smsNotify: vm.sendSms, emailNotify: vm.sendEmail }, vm.staffName, schedule));
      }
      store.dispatch(bookingActions.setBookingIdsForCouchResponse(bookingIds));
      $q.all(promises).then(function () {
        if (vm.timeoutForLoading) {// this condition should not trigger but just in case
          clearTimeout(vm.timeoutForLoading);
        }
        vm.timeoutForLoading = setTimeout(async () => {
          $mdDialog.hide();
          store.dispatch(bookingActions.setBookingIdsForCouchResponse([]));
          /* NBI-8261 - for some couch clusters swap booking was taking more than 10 seconds and caused the fallback to execute which resulted in the loadFloorplanBookings taking
             the old couchReducedBookings - which did not have the updated table info - So calling loadBookingsFromCurrentSchedule 1st to get the latest information from couch
             and then loading the floorplan bookings
          */
          await store.dispatch(loadBookingsFromCurrentSchedule());// couch response failed, get latest couchReducedBookings
          await store.dispatch(syncCouchBookingUpdates());// couch response failed, force reload
          store.dispatch(loadFloorplanBookings());// couch response failed, force reload

        }, 10000);
      }).catch((err) => {
        console.error('error with drag bookingsave', err);
        $mdDialog.hide();
        store.dispatch(bookingActions.setBookingIdsForCouchResponse([]));
      });
    }
  }
}
